import { render, staticRenderFns } from "./CustomTab.vue?vue&type=template&id=0bb76a22&scoped=true"
import script from "./CustomTab.vue?vue&type=script&lang=js"
export * from "./CustomTab.vue?vue&type=script&lang=js"
import style0 from "./CustomTab.vue?vue&type=style&index=0&id=0bb76a22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb76a22",
  null
  
)

export default component.exports